import { render, staticRenderFns } from "./BusinessView.vue?vue&type=template&id=3379d393&lang=pug&"
import script from "./BusinessView.vue?vue&type=script&lang=js&"
export * from "./BusinessView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports